<client-sign-selector
  #leftBoard
  [ipBoardPart]="ipBoard.boardPart"
  [project]="project"
  [verifySignSelection]="!oldSystemImmo"
  [leftRightBoard]="ipBoard.leftRightBoard"
  (signSelected)="saveCustomBoardSettings()"
  [title]="ipBoard.leftRightBoard ? 'Kies linker bord' : null"
></client-sign-selector>
<client-ip-custom-board-form
  [ipBoardPart]="ipBoard.boardPart"
  [project]="project"
  [isLeftRight]="ipBoard.leftRightBoard"
  (save)="saveCustomBoardSettings()"
></client-ip-custom-board-form>
<div class="left-right-checkbox">
  <mat-checkbox
    [(ngModel)]="ipBoard.leftRightBoard"
    (ngModelChange)="updateRightBoard()"
    [disabled]="!ipBoard.boardPart.signOptionSelected"
    [matTooltip]="
      'Gelieve eerst een bord te kiezen voor de linkerkant indien u een gecombineerd bord wenst'
    "
    [matTooltipDisabled]="ipBoard.boardPart.signOptionSelected"
  >
    <span>Combinatie van 2 borden: Linkse en rechtse kant verschillend</span>
  </mat-checkbox>
</div>
<client-sign-selector
  #rightBoard
  *ngIf="ipBoard.leftRightBoard"
  [ipBoardPart]="ipBoard.otherSideBoardPart"
  [leftBoardMeasurement]="
    ipBoard.boardPart.sign
      | ipBoardMeasurement
        : ipBoard.boardPart.otherHeight
        : ipBoard.boardPart.otherWidth
  "
  [project]="project"
  [verifySignSelection]="!oldSystemImmo"
  (signSelected)="save.emit()"
  title="Kies rechter bord"
  [leftRightBoard]="true"
  [isRightBoard]="true"
  [pairedSignId]="ipBoard?.boardPart?.sign?.pairedSignId"
></client-sign-selector>
<div class="upper-space">
  <client-ip-board-part-form
    [ipBoard]="ipBoard"
    [ipBoardPart]="ipBoard.boardPart"
    [project]="project"
    [verifySelections]="!oldSystemImmo"
    [isLeftRight]="ipBoard.leftRightBoard"
    (save)="save.emit()"
  ></client-ip-board-part-form>
</div>
